import { DocumentReferencesInitialState } from './types';
import { ActionTypesDocumentReferences } from './constants';

const documentReferencesInitialState: DocumentReferencesInitialState = {
  documentReferencesData: [],
  showDocumentReferencesGrid: false,
  isDocumentReferencesGridLoading: false,
  disabledColumns: [],
};

const documentReferencesReducer = (state = documentReferencesInitialState, action) => {
  switch (action.type) {
    case ActionTypesDocumentReferences.SET_DOCUMENT_REFERENCES_DATA:
      return {
        ...state,
        documentReferencesData: action.documentReferencesData,
      };
    case ActionTypesDocumentReferences.SHOW_DOCUMENT_REFERENCES_GRID:
      return {
        ...state,
        showDocumentReferencesGrid: action.showDocumentReferencesGrid,
      };
    case ActionTypesDocumentReferences.SET_LOADING_INDICATOR:
      return {
        ...state,
        isDocumentReferencesGridLoading: action.isDocumentReferencesGridLoading,
      };
    case ActionTypesDocumentReferences.RESET_DOCUMENT_REFERENCES_DATA:
      return {
        ...state,
        documentReferencesData: [],
        showDocumentReferencesGrid: false,
      };
    case ActionTypesDocumentReferences.SET_DISABLED_COLUMNS:
      return {
        ...state,
        disabledColumns: action.disabledColumns,
      };
    default:
      return state;
  }
};

export default documentReferencesReducer;
